{
  "startNew": "Empezar de nuevo",
  "table": {
    "createdAt": "Se ejecutó en",
    "completedAt": "Completado en",
    "state": "Estado",
    "files": "Archivos",
    "organization": "Organización"
  },
  "state": {
    "CANCELED": "Cancelado",
    "COMPLETED": "Completado",
    "DRAFT": "Borrador",
    "REQUESTED": "Solicitado"
  },
  "allocationFile": "Asignaciones",
  "ptfAllocationFile": "Asignaciones PTF",
  "generating": "Generar",
  "reviewTrades": "Revisar operaciones",
  "updateTrades": "Actualizar operaciones completadas",
  "reviewTradeAllocations": "Revisar las asignaciones comerciales",
  "updatePTFTrades": "Actualización de las operaciones completadas de PTF",
  "reviewPTFTradeAllocations": "Revisar las asignaciones comerciales del PTF",
  "completed": "Completado",
  "generatingDescription": "Se están generando operaciones ahora mismo...",
  "rebalanceOn": "Reequilibrar en",
  "rebalanceCanceled": "El reequilibrio se ha cancelado, regrese para iniciar uno nuevo.",
  "tradeViaFix": "Operaciones a través de FIX",
  "bulkBUYTrades": "Operaciones de compras por lotes",
  "bulkSELLTrades": "Operaciones de ventas por lotes",
  "bulkMutualFundBUYTrades": "Compras por lotes de fondos de inversión",
  "bulkMutualFundSELLTrades": "Ventas por lotes de fondos de inversión",
  "amountValue": "Valor",
  "cancelRebalanceTrades": "Cancelar operaciones de reequilibrio",
  "rebalanceCompleted": "Reequilibrio completado",
  "allPricesNotUpdated": "Todos los precios aún no están actualizados",
  "pasteFromExcel": "Copiar/Pegar desde Excel",
  "orderOfContent": "Asegúrese de que las columnas estén ordenadas por ticker, precio y cantidad",
  "cancelConfirmationDialog": "Antes de cancelar, asegúrese de que no ha enviado los archivos de operaciones por lotes. Si ya ha enviado los archivos de operaciones por lotes, el sistema mostrará un ERROR, ya que todas esas operaciones se han enviado al administrador.",
  "cancelTriggeredMessage": "¡Se activó la cancelación de las operaciones de reequilibrio!",
  "discrepancyConfirmationDialog": {
    "title": "Discrepancias en transacciones por lotes",
    "text": "Existen discrepancias relevantes en las cantidades asignadas o en los precios. ¿Está seguro de que desea continuar?"
  },
  "orderOfPortfolioContent": "Asegúrese de que las columnas estén ordenadas por ticker y porcentaje",
  "generate": "Generar",
  "bulkTraderOn": "Operaciones por lotes negociadas en",
  "bulkTradeRunCompleted": "Operación por lotes completada",
  "bulkTradeRunCanceled": "Operación comercial por lotes cancelada",
  "saveTradesMessage": "Guarde sus operaciones para continuar.",
  "securitiesWereNotFound": "No se encontraron valores: {{securities}}",
  "dialog": {
    "title": "Solicitud de comercio por lotes"
  },
  "security": "Valor",
  "price": "Precio",
  "quantity": "Cantidad",
  "save": "Guardar",
  "update": "Actualizar",
  "cancel": "Cancelar",
  "back": "Atrás",
  "next": "Siguiente",
  "cancelBulkTradeRunTrades": "Cancelar Operaciones Comerciales por Lotes",
  "buyTradeFile": "Archivo de Operaciones de Compra",
  "sellTradeFile": "Archivo de Operaciones de Venta",
  "mutualFundTradeFile": "Archivo de Operaciones de Fondos de Inversión",
  "buySellTradeFile": "Archivo de Operaciones de Compra/Venta",
  "ptfBulkTradeFile": "Archivo de Operaciones por Lotes de PTF"
}
